import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import signUp from '../views/signUp.vue'
import Main from '../views/Main.vue'
import Layout from '../views/layout/index.vue'
import SettlementDashboard from '../components/dashboard'
import CouponDashboard from '../components/dashboardCoupon.vue'
import AccountantSettlementList from '../components/settlement/settlementList.vue'
import DriverSettlementList from '../components/settlement/settlementListDriver.vue'
import addDiscount from '../components/discount/addDiscount.vue'
import detailDiscount from '../components/discount/detailDiscount.vue'
import discountList from '@/components/discount/discountList.vue'
import SettlementAct from '../components/settlement/settlementAct.vue'
import { AmplifyEventBus } from 'aws-amplify-vue'
import { getUser, getGroups } from '@/utils/auth.js'
Vue.use(VueRouter)

export const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/main',
      children: [
        {
          path: '/main',
          name: 'main',
          component: Main
        },
        {
          path: '/settlementDashboard',
          name: 'settlementDashboard',
          component: SettlementDashboard
        },
        {
          path: '/couponDashboard',
          name: 'couponDashboard',
          component: CouponDashboard
        },
        {
          path: '/settlement-list',
          name: 'settlementList',
          component: AccountantSettlementList
        },
        {
          path: '/settlementlist-driver',
          name: 'settlementListDriver',
          component: DriverSettlementList
        },
        {
          path: '/settlement-act',
          name: 'settlementAct',
          component: SettlementAct
        },
        {
          path: '/discount-list',
          name: 'discounts',
          component: discountList
        },
        {
          path: '/addDiscount',
          name: 'addDiscount',
          component: addDiscount
        },
        {
          path: '/detailDiscount/:id',
          name: 'detailDiscount',
          component: detailDiscount
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/signUp',
      name: 'signUp',
      component: signUp,
      meta: { requiresAuth: false }
    }
  ]
})

AmplifyEventBus.$on('authState', async state => {
  const pushPathes = {
    signedOut: () => {
      router.push({ path: '/login' })
      localStorage.clear()
    },
    signUp: () => {
      router.push({ path: '/signUp' })
    },
    confirmSignUp: () => {
      router.push({ path: '/signUpConfirm' })
    },
    login: () => {
      router.push({ path: '/login' })
    },
    signedIn: () => {
      router.push({ path: '/main' })
    }
  }
  if (typeof pushPathes[state] === 'function') {
    pushPathes[state]()
  }
})

router.beforeResolve(async (to, from, next) => {
  const user = await getUser()
  const group = await getGroups()
  if (!user) {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      return next({
        path: '/login'
      })
    }
  } else {
    try {
      if (to.name === 'settlementList' || to.name === 'settlementListDriver' || to.name === 'settlementHistoryAccountant') {
        if (!group.includes('boss') && !group.includes('accountant') && !group.includes('view')) {
          return next({ path: '/main' })
        } else return next()
      }
    } catch (error) {
      return next({
        path: '/'
      })
    }
  }
  return next()
})
export default { router }
